/*
*   Shared UI Components JavaScript
*   Common functionality used across all themes and projects
*/

$(document).ready(function() {
    // Initialize Foundation - REQUIRED for accordions, dropdowns, tabs, off-canvas, etc.
    $(document).foundation();

    /*
    * Header functionality - shared across all themes
    */

    // Initialize: Remove dropdown children from tab order when closed
    $('.menu-item-has-children ul a').attr('tabindex', '-1');

    // Search toggle functionality
    $('.mag-glass').click(function() {
        $(this).toggleClass('active');
        $(this).closest('.inner').toggleClass('active');
        $('.search-form').toggleClass('active');
        return false;
    });

    // 12043 — a dropdown parent may carry a real destination (navFolderLink): those parents
    // must NAVIGATE, not just toggle. Unlinked parents keep href="#" and only toggle.
    function hasRealHref($link) {
        var href = $link.attr('href');
        return !!href && href !== '#' && href.indexOf('javascript:') !== 0;
    }

    // Desktop = the same "large" breakpoint the CSS hover-open rule uses (_header.scss),
    // so click never needs to open the submenu there — hover already has.
    function isDesktopNav() {
        if (window.Foundation && Foundation.MediaQuery && typeof Foundation.MediaQuery.atLeast === 'function') {
            return Foundation.MediaQuery.atLeast('large');
        }
        return window.matchMedia('(min-width: 64em)').matches;
    }

    // Dropdown menu functionality - click handler
    $('.menu-item-has-children > a').on('click', function(e) {
        var $link = $(this);
        // Linked parent: desktop click follows the link (hover opens the menu); on smaller
        // screens the first tap opens the submenu and a second tap, while open, follows it.
        if (hasRealHref($link) && (isDesktopNav() || $link.parent().hasClass('active'))) {
            return;
        }
        e.preventDefault();
        toggleDropdown($link);
    });

    // Dropdown menu - keyboard support for accessibility
    $('.menu-item-has-children > a').on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            // Enter on a linked parent keeps native anchor behaviour (navigates);
            // Space always toggles, as does Enter on an unlinked parent.
            if (e.key === 'Enter' && hasRealHref($(this))) {
                return;
            }
            e.preventDefault();
            toggleDropdown($(this));
        }
        // Arrow down to open and focus first item
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            var $parent = $(this).parent();
            if (!$parent.hasClass('active')) {
                toggleDropdown($(this));
            }
            $parent.find('ul li:first-child a').focus();
        }
    });

    // Escape key closes all dropdowns and returns focus to parent
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            var $activeDropdown = $('.menu-item-has-children.active');
            if ($activeDropdown.length) {
                $activeDropdown.find('ul a').attr('tabindex', '-1');
                $activeDropdown.removeClass('active')
                    .find('> a').attr('aria-expanded', 'false').focus();
            }
        }
    });

    // Helper function to toggle dropdown
    function toggleDropdown($link) {
        var $parent = $link.parent();
        var isOpen = $parent.hasClass('active');

        // Close other dropdowns first and remove from tab order
        $parent.siblings('.menu-item-has-children')
            .removeClass('active')
            .find('> a').attr('aria-expanded', 'false')
            .end().find('ul a').attr('tabindex', '-1');

        // Toggle current dropdown
        $parent.toggleClass('active');
        $link.attr('aria-expanded', !isOpen);

        // Update tabindex for dropdown children
        if (!isOpen) {
            // Opening: add to tab order
            $parent.find('ul a').attr('tabindex', '0');
        } else {
            // Closing: remove from tab order
            $parent.find('ul a').attr('tabindex', '-1');
        }
    }

    /*
    * Video player thumbnail overlay
    * Clicking the overlay hides it and triggers iframe autoplay
    */
    $('.video-thumbnail-overlay').on('click', function() {
        var $overlay = $(this);
        var embedUrl = $overlay.data('embed-url');
        var $iframe = $overlay.siblings('iframe');
        if (embedUrl && $iframe.length) {
            var separator = embedUrl.indexOf('?') > -1 ? '&' : '?';
            $iframe.attr('src', embedUrl + separator + 'autoplay=1');
        }
        $overlay.fadeOut(200, function() { $overlay.remove(); });
    });

    /*
    * 13182 follow-up round 2 — hero + read-more sidebar full-bleed
    *
    * On a page with the read-more sidebar, .banner--hero's own containing block (the 9-col main
    * cell) isn't centred on the viewport the way it is on a normal page, so the CSS breakout's
    * fixed vw-centring math (_banner13208.scss) can't reach the true viewport edges by a formula
    * alone - see that file for the full root-cause writeup. This measures the hero's own live
    * distance from the viewport's left edge and writes it to a CSS custom property; the CSS then
    * subtracts it back out via margin-left, landing the breakout at the true viewport edge
    * regardless of viewport width or how the column layout happens to be nested. A no-op on
    * every page without a .read-more-layout .banner--hero (the vast majority of pages) and on
    * KD/MHL/PD only (the only themes with a `.banner--hero` at all).
    */
    function updateHeroBleed() {
        var $hero = $('.read-more-layout .banner--hero');
        if (!$hero.length) {
            return;
        }
        $hero.each(function () {
            var left = this.getBoundingClientRect().left;
            this.style.setProperty('--hero-bleed-left', left + 'px');
        });
    }
    updateHeroBleed();
    var heroBleedResizeTimer;
    $(window).on('resize', function () {
        clearTimeout(heroBleedResizeTimer);
        heroBleedResizeTimer = setTimeout(updateHeroBleed, 150);
    });

    /*
    * 13242 — back-to-top button. Compiled into every theme's shared bundle, but a no-op
    * everywhere except kd/mhl: those two themes set `--mw-back-to-top: 1` on :root
    * (kd|mhl/umbraco/_backtotop13242.scss) as an explicit opt-in flag, so this reads that
    * flag FIRST and returns immediately for every other theme (mwdh, dallah, hail, ndh,
    * nwl, somerset, manchester, nel...), which never sets the property and so never gets
    * the button injected, styled or wired up. No Razor view change — the button element
    * itself is created here, not in a .cshtml partial.
    */
    function initBackToTop() {
        var enabled = getComputedStyle(document.documentElement)
            .getPropertyValue('--mw-back-to-top')
            .trim();
        if (enabled !== '1') {
            return;
        }

        var $button = $(
            '<a href="#top" class="mw-back-to-top" aria-label="Back to top">' +
                '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
                    '<path d="M4 15l8-8 8 8" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
                '</svg>' +
            '</a>'
        );
        $('body').append($button);

        // Old site's own threshold (Bootstrap affix) is roughly one viewport height down;
        // mirrored here rather than an arbitrary pixel guess.
        function updateVisibility() {
            // A theme can set --mw-back-to-top-after (px); otherwise the earlier viewport-based guess.
            var custom = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mw-back-to-top-after'), 10);
            var showAfter = custom > 0 ? custom : Math.max(300, window.innerHeight * 0.75);
            $button.toggleClass('is-visible', window.scrollY > showAfter);
        }
        updateVisibility();
        var scrollTimer;
        $(window).on('scroll', function () {
            if (scrollTimer) {
                return;
            }
            scrollTimer = setTimeout(function () {
                updateVisibility();
                scrollTimer = null;
            }, 100);
        });

        // #top scrolls the page natively (browsers special-case an empty/"top" fragment),
        // but with no element actually named "top" it does not move keyboard focus anywhere
        // — the user's focus would stay stranded down the page. Move it somewhere sensible:
        // the site logo link, the first focusable thing in the header, and itself a genuine
        // in-page anchor rather than a tabindex hack.
        $button.on('click', function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            var $target = $('header.main-header a').first();
            if ($target.length) {
                $target.trigger('focus');
            }
        });
    }
    initBackToTop();

    /*
    * Mobile menu functionality - shared across all themes
    */
    $('#menu-toggle').on('change', function () {
        if ($(this).is(':checked')) {
            $('.main-menu').addClass('open').css('max-height', $('.main-menu')[0].scrollHeight + '2px');
            $(this).closest('.inner').addClass('active');
            $('body').addClass('menu-open');
        } else {
            $('.main-menu').css('max-height', '0');
            $(this).closest('.inner').removeClass('active');
            $('body').removeClass('menu-open');
            // Wait for transition to complete before removing class (avoids abrupt disappearance)
            setTimeout(() => {
                $('.main-menu').removeClass('open');
            }, 300); // Matches transition duration in CSS
        }
    });
});